document.addEventListener("DOMContentLoaded", function(event) {
  var page_url = window.location.href;

  if (page_url.endsWith('/login') || page_url.endsWith('/login?return_url=%2Faccount')) {
  } 

  /* Subscription page */
  else if (page_url.indexOf('/tools/recurring/customers/') >= 0) {
    if (page_url.indexOf('subscriptions') >= 0) {
      if ($('.rc_button.rc_button--fa-plus-circle ').length) {
        /* $('.rc_button.rc_button--fa-plus-circle ').parent().append('<span class="rc-disclaimer"><p>Add the new Plant Collagen Support mix to your upcoming order to secure your mix!<br><em>Please Note</em>&nbsp;this is currently available for PRE-ORDER. Your entire order will be shipped the first week of September.</p></span>'); */
      }
    }
    if ($('#rc_navigation').length) {
      $('#rc_navigation').append('<li class="rc_menu__item"><a href="/pages/exclusive-content">My Exclusive Content</a></li>')
    }
    
    // bfcm banner
    var desktop_img = "//cdn.shopify.com/s/files/1/1556/2685/files/rc-bfcm-desktop1.jpg?v=10007324836853030617";
    var mobile_img = "//cdn.shopify.com/s/files/1/1556/2685/files/rc-bfcm-mobile1.jpg?v=13052819198585990707";
    var banner_html = '<div class="bfcm-banner"><img class="rc-bfcm__banner--desktop" src="' + desktop_img + '"><img class="rc-bfcm__banner--mobile" src="' + mobile_img + '"></div>';
    /*$('.container.main').prepend(banner_html);*/
  }
  
  else if (page_url.indexOf('account') >= 0) {
  }
});